import React, { useEffect, useMemo } from 'react';
import { Redirect, Route } from 'react-router-dom';

interface Params {
  path?: string;
  exact?: boolean;
}

const PrivateRoute: React.FC<Params> = ({ path, exact, children, ...props }) => {
  const TOKEN_NAME = useMemo(() => process.env.REACT_APP_TOKEN_NAME || 'session-token', []);

  const token = useMemo(() => localStorage.getItem(TOKEN_NAME) || '', []);

  useEffect(() => {
    if (!token) {
      window.location.href = '/login';
    }
  }, [token]);

  return <Route {...props} path={path} exact={exact} render={() => <>{children}</>} />;
};

export default PrivateRoute;
